import { SVGAttributes } from 'react'

export default function WirelessIcon(attributes: SVGAttributes<SVGSVGElement>): JSX.Element {
	return (
		<svg {...attributes} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 64">
			<path className="text-gray-800" d="M32.454 63.908c17.648 0 31.954-14.306 31.954-31.954C64.408 14.306 50.102 0 32.454 0 14.806 0 .5 14.306.5 31.954c0 17.648 14.306 31.954 31.954 31.954z" fill="currentColor"/>
			<path className="text-gray-300" d="M16.844 40.953h-5.693v7.53h5.693v-7.53zM25.843 34.433h-6.244v14.05h6.244v-14.05zM34.933 28.098H28.69V48.39h6.244V28.098z" fill="currentColor"/>
			<path className="text-white" d="M43.84 21.854h-6.244v26.628h6.244V21.854z" fill="currentColor"/>
			<path className="text-green-400" d="M52.196 15.518h-5.693v32.964h5.693V15.518z" fill="currentColor"/>
		</svg>
	)
}
